import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  defaultText: {
    fontWeight: 'normal',
    color: theme.colors.black,
  },
});
